import { chairsTableParasol, sunloungerParasolSunPalmtree } from '@lucide/lab';
import {
  AirVent,
  Anchor,
  BedDouble,
  Bot,
  Bug,
  Building2,
  Car,
  Dog,
  Droplets,
  Heart,
  Home,
  Hotel,
  KeyRound,
  Landmark,
  Laptop,
  Luggage,
  MessagesSquare,
  Microwave,
  Mountain,
  PlaneTakeoff,
  Refrigerator,
  Sailboat,
  Scale,
  ShoppingCart,
  Smartphone,
  Sparkles,
  Star,
  Sun,
  Tag,
  TreePalm,
  TreePine,
  Truck,
  Tv,
  User,
  Users,
  UtensilsCrossed,
  WashingMachine,
  Wrench,
  T10,
  createLucideIcon,
  type LucideIcon,
  type LucideProps,
} from 'lucide-react';

const ChairsTableParasol = createLucideIcon('ChairsTableParasol', chairsTableParasol);
const SunloungerParasolSunPalmtree = createLucideIcon(
  'SunloungerParasolSunPalmtree',
  sunloungerParasolSunPalmtree,
);

const ICONS: Record<string, LucideIcon> = {
  AirVent,
  Anchor,
  BedDouble,
  Bot,
  Bug,
  Building2,
  Car,
  ChairsTableParasol,
  Dog,
  Droplets,
  Heart,
  Home,
  Hotel,
  KeyRound,
  Landmark,
  Laptop,
  Luggage,
  MessagesSquare,
  Microwave,
  Mountain,
  PlaneTakeoff,
  Refrigerator,
  Sailboat,
  Scale,
  ShoppingCart,
  Smartphone,
  Sparkles,
  Star,
  Sun,
  SunloungerParasolSunPalmtree,
  Tag,
  TreePalm,
  TreePine,
  Truck,
  Tv,
  User,
  Users,
  UtensilsCrossed,
  WashingMachine,
  Wrench,
  T10,
};

interface DynamicIconProps extends LucideProps {
  name: string;
}

export function DynamicIcon({ name, ...props }: DynamicIconProps) {
  const IconComponent = ICONS[name] || MessagesSquare;
  return <IconComponent {...props} />;
}
